import { render, staticRenderFns } from "./TemplateAdd.vue?vue&type=template&id=6cc4be94&scoped=true&"
import script from "./TemplateAdd.vue?vue&type=script&lang=js&"
export * from "./TemplateAdd.vue?vue&type=script&lang=js&"
import style0 from "./TemplateAdd.vue?vue&type=style&index=0&id=6cc4be94&lang=scss&"
import style1 from "./TemplateAdd.vue?vue&type=style&index=1&id=6cc4be94&lang=scss&"
import style2 from "./TemplateAdd.vue?vue&type=style&index=2&id=6cc4be94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc4be94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc4be94')) {
      api.createRecord('6cc4be94', component.options)
    } else {
      api.reload('6cc4be94', component.options)
    }
    module.hot.accept("./TemplateAdd.vue?vue&type=template&id=6cc4be94&scoped=true&", function () {
      api.rerender('6cc4be94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/services/template/TemplateAdd.vue"
export default component.exports